/**
 * Downloads a file from the given URL with the specified file name.
 * @param {object} options - The options object.
 * @param {string} options.url - The URL from which to download the file.
 * @param {string} options.fileName - The name to save the downloaded file as.
 * @returns {void}
 */
export function downloadFile({
  url,
  fileName,
}: {
  url: string;
  fileName: string;
}): void {
  const link = document.createElement("a");
  link.href = url;
  link.target = "_blank";
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
}
